import type { FieldError } from '@glasses/shared'
import { errorFor } from '../lib/orderForm'

/** The field's validation message, if it has one: `.field-error[role=alert][data-error=<field>]`. */
export function ErrorText({ field, errors }: { field: string; errors: FieldError[] }) {
  const message = errorFor(errors, field)
  if (message === null) return null
  return (
    <div className="field-error" role="alert" data-error={field}>
      {message}
    </div>
  )
}
